import { airway_number } from "@/api/packing/packing.js";
import { planList } from "./localData.js";
import getLodop, { printType } from "@/utils/lodop";
export const modals = ({ that }) => {
  return {
    changeTemuAccount: {
      type: 'add',
      methods: {
        ok({ row, close }) {
          let data = this.handleFilterData()
          data.airway_number = data.airway_number.split('\n')
          this.$page.handleRequestMethods('changeTemuAccount', data, true, true).then(res => {
            this.$page.getList();
            close();
          })
        }
      },
      config: {
        title: that.$tz('TEMU拆段转专线'),
        modalBind: {
          width: 500
        },
        formBind: {
          labelWidth: 100
        },
        rowBind: {
          gutter: 16,
          style: {
            marginBottom: '20px'
          }
        },
        rules: {
          airway_number: [
            {
              required: true,
              message: 'cannot be empty',
              trigger: 'blur',
            },
          ],
        }
      },
      grid: [
        { airway_number: 24 }
      ],
      fields: [
        {
          key: 'airway_number',
          name: () => that.$tz('订单号码'),
          placeholder() {
            return that.$tz('订单号码');
          },
          component: 'Input',
          bind: {
            type: 'textarea',
            autosize: { minRows: 4 },
          },
        },
      ]
    },
    preview: {
      config: {
        title: that.$t("preview")
      },
      contentSlot: "PREVIEW",
      footer: {
        show: false
      }
    },
    unbox: {
      methods: {
        ok({ row, close }) {
          this.$page.handleRequestMethods("unbox", row, true, true).then((res) => {
            close();
          });
        },
      },
      config: {
        title: that.$tz('是否开箱'),
        modalBind: {
          width: 600
        },
        formBind: {
          labelWidth: 80
        },
        rowBind: {
          gutter: 16,
          style: {
            marginBottom: "20px"
          }
        },
        rules: {
          unbox: [
            {
              required: true,
              message: "cannot be empty",
              trigger: "blur",
            },
          ],
        }
      },
      grid: [{ unbox: 24 }],
      fields: [
        {
          key: "unbox",
          name: that.$tz("是否开箱"),
          placeholder: () => that.$tz("是否开箱"),
          component: "Select",
          options: [],
          optionsFn: 'YesNo'
        }
      ]
    },
    printLabel: {
      methods: {
        open({ fields }) {
          this.timer = setInterval(() => {
            if (!this.offFocus) this.$refs.form.getRef('airway_number').focus()
          }, 2000)
        },
        cancel() {
          clearInterval(this.timer)
        }
      },
      config: {
        title: that.$t('printLabel'),
        modalBind: {
          width: 600
        },
        formBind: {
          labelWidth: 80
        },
        rowBind: {
          gutter: 16,
          style: {
            marginBottom: "20px"
          }
        }
      },
      footer: {
        show: () => false,
      },
      grid: [{ type: 24 }, { size: 24 }, { fixedClearance: 24 }, { airway_number: 24 }],
      fields: [
        {
          name: that.$tz('尺寸'),
          key: 'size',
          component: 'Radio',
          options: [
            { label: '100*150', value: 0 },
            { label: '100*200', value: 1 },
          ],
          optionsFn: '',
          optionsKey: '',
          default: 0,
          bind: {
            border: true
          }
        },
        {
          name: that.$tz('单,Logo'),
          key: 'fixedClearance',
          component: 'Radio',
          options: [],
          optionsFn: 'YesNoNumber',
          optionsKey: '',
          default: 0,
          bind: {
            border: true
          }
        },
        {
          key: "airway_number",
          name: () => that.$t("orderNum"),
          component: "Input",
          placeholder() {
            return that.$t("enter") + that.$t("orderNum");
          },
          bind: {
            focus: true
          },
          methods: {
            'on-enter'({ formData }) {
              let airway_number = formData.airway_number.toUpperCase()
              formData.airway_number = ''
              if (this.$page.isErr) return
              console.log(formData)
              // 验证 airway_number 是否是CNT开头加8位数字,如果不是就报错
              // if (!/^CNT\d{8}$/.test(airway_number)) {
              //   this.$Message.error({
              //     content: this.$tz('单号,错误'),
              //     background: true
              //   });
              //   this.$page.playMusic('false')
              //   return
              // }

              if (this.old_airway_number === airway_number) {
                this.$Message.error(({
                  content: this.$t('re_enter'),
                  background: true
                }))
                this.$page.playMusic('false')
                return
              }
              this.old_airway_number = airway_number
              let data = {
                miniLabel: false,
                specialLable: formData.size ? false : true,
                single: true,
                orders: [airway_number]
              };
              if (formData.fixedClearance) data.fixedClearance = 'NONE'
              this.$page.handleRequestMethods('postSheet', data, true, true).then(res => {
                let url =
                  res.payload[0].link &&
                  res.payload[0].link.replace("https://", "http://");
                let LODOP = getLodop(that);
                this.$Message.success({
                  content: that.$t('startPrint'),
                  background: true
                });
                this.$page.playMusic('success')
                console.log(url);
                let sizes = {
                  0: ['100mm', '150mm'],
                  1: ['100mm', '200mm']
                }
                LODOP.PRINT_INIT("打印任务名"); //首先一个初始化语句
                console.log(sizes[formData.size])
                LODOP.SET_PRINT_PAGESIZE(1, sizes[formData.size][0], sizes[formData.size][1], ""); //规定纸张大小；使用A4纸
                LODOP.SET_PRINTER_INDEX(formData.type);
                LODOP.SET_PRINT_STYLE("Alignment", 2);
                LODOP.ADD_PRINT_PDF(0, 0, sizes[formData.size][0], sizes[formData.size][1], url);
                LODOP.PRINT(); //打印预览
              }).catch(err => {
                this.$page.isErr = true
                this.$page.playMusic('false')
                console.error(airway_number);
                console.error(err);
                console.log(this.$page);
                this.$Modal.error({
                  title: this.$tz('提示'),
                  content: err.data.message,
                  onOk: () => {
                    this.$page.isErr = false
                  },
                  onCancel: () => {
                    this.$page.isErr = false
                  }
                });
              })
            }
          }
        },
        {
          key: "type",
          name: that.$tz("打印机"),
          component: "Select",
          options: [],
          default: -1,
          placeholder: () => that.$tz("请选择,打印机"),
          methods: {
            list({ field }) {
              field.options = printType.call(that);
            },
            'on-change'({ fields }) {
              setTimeout(() => {
                this.$form.getRef('airway_number').focus()
              }, 200)
            },
            'on-open-change'(_, state) {
              this.$form.offFocus = state
            }
          }
        }
      ]
    },
    log: {
      config: {
        modalBind: {
          width: 60,
        },
        modalContentBind: {
          style: "height:60vh;overflow-x:hidden;overflow-y:auto;",
        },
      },
      footer: {
        show: false,
      },
      fields: [],
      table: {
        config: {
          align: "center",
          height: 500,
        },
        fields: [

          {
            name: () => that.$t("operate"),
            key: "operator_name",
            align: "center",
            width: 150,
          },
          {
            name: () => that.$t("createTime"),
            key: "create_time",
            width: 150,
          },
          {
            name: () => that.$t("operation content"),
            key: "remarks",
            align: "center",
            minWidth: 110,
          },

        ],
      },
    },
    print: {
      config: {
        listFn: "list",
        modalBind: {
          width: "80%",
        },
      },
      methods: {
        ok({ row, close }) {
          let obj = {
            miniLabel: row.type ? true : false,
            single: true,
            orders: row.orders.split(/\n/),
          };
          that.$page.handleRequestMethods("postPdf", obj).then((res) => {
            close();
            window.open(res.payload.mergeFile, "_blank");
          });
        },
      },
      footer: {
        ok: {},
        cancel: {},
      },
      config: {
        modalBind: {
          width: 600,
        },
        formBind: {
          labelWidth: 100,
        },
        rowBind: {
          gutter: 16,
          style: {
            marginBottom: "20px",
          },
        },
      },
      grid: [
        {
          orders: 24,
        },
        {
          type: 24,
        },
      ],
      fields: [
        {
          name: () => that.$t("order_number"),
          component: "Input",
          bind: {
            placeholder: "Please Enter Code",
            type: "textarea",
            rows: 8,
          },
          key: "orders",
        },
        {
          name: () => that.$t("type"),
          bind: {
            placeholder: "Please Enter Code",
          },
          component: "Select",
          key: "type",
          config: {
            label({ row, field }) {
              return that.$t(row.label);
            },
          },
          options: [
            {
              label: "sheetMini",
              value: 1,
            },
            {
              label: "sheetStandard",
              value: 0,
            },
          ],
        },
      ],
    },
    orderDetail: {
      contentSlot: "ORDERDETAIL",
      config: {
        listFn: "list",
        modalBind: {
          width: "80%",
        },
      },
      footer: {
        show: false,
      },
    },
    orderTracker: {
      contentSlot: "ORDERTRACKER",
      config: {
        listFn: "list",
        modalBind: {
          width: "30%",
        },
      },
      footer: {
        show: false,
      },
    },
    planReturn: {
      config: {
        listFn: "list",
        modalBind: {
          width: "80%",
        },
      },
      methods: {
        ok({ row, close }) {
          that.handleRequestMethods("returnPlan", row, true).then((e) => {
            that.getList();
            close();
          });
        },
      },
      footer: {
        ok: {},
        cancel: {},
      },
      config: {
        modalBind: {
          width: 600,
        },
        formBind: {
          labelWidth: 100,
        },
        rowBind: {
          gutter: 16,
          style: {
            marginBottom: "20px",
          },
        },
        rules: {
          plan: [
            {
              required: true,
              message: "plan cannot be empty",
              trigger: "blur",
            },
          ],
          payment_type: [
            {
              required: true,
              message: "payment_type cannot be empty",
              trigger: "blur",
              type: "number",
            },
          ],
        },
      },
      grid: [
        {
          plan: 24,
        },
        {
          payment_type: 24,
        },
        {
          plan_remark: 24,
        },
      ],
      fields: [
        {
          key: "plan",
          name: () => that.$t("plan"),
          component: "Select",
          placeholder() {
            return this.$t("select") + this.$t("plan");
          },
          options: planList,
          config: { label: ({ row }) => that.$t(row.label) },
        },
        {
          key: "payment_type",
          name: () => that.$t("paymentType"),
          component: "Select",
          show: ({ row }) => row.plan == "sendExpress",
          placeholder() {
            return this.$t("select") + this.$t("paymentType");
          },
          options: [],
          methods: {
            async list({ field, formData }) {
              let res = (
                await that.handleRequestMethods(
                  "getSelectType",
                  "RETURN_PAYMENT_TYPE"
                )
              ).payload["RETURN_PAYMENT_TYPE"];
              field.options = res;
              this.$forceUpdate();
              // this.$nextTick(() => {
              //   formData.currency = field.options[0].code;
              // });
            },
          },
        },
        {
          name: () => that.$t("plan_remark"),
          component: "Input",
          bind: {
            type: "textarea",
            rows: 5,
          },
          placeholder() {
            return this.$t("enter") + this.$t("plan_remark");
          },
          key: "plan_remark",
        },
      ],
    },
    checkWeight: {
      config: {
        listFn: "list",
        modalBind: {
          width: "80%",
        },
      },
      methods: {
        ok({ row, close }) {
          that.handleRequestMethods("checkWeight", row, true).then((e) => {
            if (this.list.length) {
              this.list.push({
                airway_number: row.airway_number,
                msg: e.msg,
                code: e.code,
              });
            } else {
              this.list = [
                {
                  airway_number: row.airway_number,
                  msg: e.msg,
                  code: e.code,
                },
              ];
            }
            console.log("this.list", this.list);

            this.$refs["form"].clear();
            // that.$page.getList();
            // that.close();
          });
        },
      },
      footer: {
        ok: {
          name: () => that.$t("IncomingInspection"),
        },
        cancel: {},
      },
      config: {
        modalBind: {
          width: 600,
        },
        formBind: {
          labelWidth: 100,
        },
        rowBind: {
          gutter: 16,
          style: {
            marginBottom: "20px",
          },
        },
        rules: {
          airway_number: [
            {
              required: true,
              message: "airway number be empty",
              trigger: "blur",
            },
          ],
          weight: [
            {
              required: true,
              message: "weight be empty",
              trigger: "blur",
            },
          ],
        },
      },
      grid: [
        {
          airway_number: 24,
        },
        {
          weight: 24,
        },
      ],
      fields: [
        {
          key: "airway_number",
          name: () => that.$t("orderNum"),
          component: "Input",
          placeholder() {
            return that.$t("enter") + that.$t("orderNum");
          },
        },
        {
          name: () => that.$t("invoiceWeight"),
          component: "Input",
          placeholder() {
            return that.$t("enter") + that.$t("invoiceWeight");
          },
          key: "weight",
        },
      ],
      table: {
        config: {
          height: 300,
        },
        fields: [
          {
            name: () => that.$t("orderNum"),
            key: "airway_number",
            align: "center",
            minWidth: 140,
          },
          {
            name: () =>
              that.$t("whether") + that.$t("can") + that.$t("inbound"),
            align: "center",
            key: "code",
            minWidth: 80,
            render(h, { row }) {
              return h(
                "span",
                {
                  style: {
                    color: row.code ? "red" : "green",
                  },
                },
                row.code ? "NO" : "YES"
              );
            },
          },
          {
            name: () => that.$t("tip1"),
            align: "center",
            key: "msg",
            minWidth: 110,
          },
        ],
      },
    },
    addRemark: {
      methods: {
        ok({ row, close }) {
          that.handleRequestMethods("addNewRemark", row, true).then((res) => {
            that.getList();
            close();
          });
        },
      },
      config: {
        rules: {
          remarks: [
            {
              required: true,
              message: "remarks be empty",
              trigger: "bulr",
            },
          ],
        },
        formBind: {
          labelWidth: 100,
        },
        title: that.$t("add") + that.$t("order_desc"),
        rowBind: {
          gutter: 16,
          style: {
            marginBottom: "20px",
          },
        },
      },
      grid: [{ remarks: 24 }],
      fields: [
        {
          key: "remarks",
          name: () => that.$t("order_desc"),
          component: "Input",
          placeholder() {
            return that.$t("enter") + that.$t("order_desc");
          },
          bind: {
            type: "textarea",
            rows: 5,
          },
        },
      ],
    },
    ortherCost: {
      methods: {
        ok({ row, close }) {
          that.handleRequestMethods("addOtherFee", row, true).then((e) => {
            that.getList();
            close();
          });
        },
      },
      footer: {
        ok: {},
        cancel: {},
      },
      config: {
        modalBind: {
          width: 600,
        },
        formBind: {
          labelWidth: 100,
        },
        rowBind: {
          gutter: 16,
          style: {
            marginBottom: "20px",
          },
        },
        rules: {
          service_type: [
            {
              required: true,
              message: "plan cannot be empty",
              trigger: "blur",
              type: "number",
            },
          ],
          currency: [
            {
              required: true,
              message: "plan cannot be empty",
              trigger: "change",
            },
          ],
          fee: [
            {
              required: true,
              message: "plan cannot be empty",
              trigger: "blur",
              type: "number",
            },
          ],
        },
      },
      grid: [
        {
          service_type: 24,
        },
        {
          currency: 24,
        },
        {
          fee: 24,
        },
      ],
      fields: [
        {
          key: "service_type",
          name: () => that.$t("orther") + that.$t("cost_t"),
          component: "Select",
          placeholder() {
            return that.$t("select") + that.$t("orther") + that.$t("cost_t");
          },
          options: [],
          methods: {
            async list({ field, searchForm }) {
              let res = (await that.handleRequestMethods("getOtherFee"))
                .payload;
              field.options = res;
              this.$forceUpdate();
            },
          },
        },
        {
          key: "currency",
          name: () => that.$t("currency_t"),
          component: "Select",
          placeholder() {
            return that.$t("select") + that.$t("currency_t");
          },
          show({ row }) {
            return row.service_type == 2068;
          },
          options: [],
          config: {
            label: "title",
            value: "code",
          },
          methods: {
            async list({ field, formData }) {
              let res = (await that.handleRequestMethods("getCurrency")).payload
                .rows;
              field.options = res;
              this.$forceUpdate();
              this.$nextTick(() => {
                formData.currency = field.options[0].code;
              });
            },
          },
        },
        {
          name: () => that.$t("reChAmount"),
          key: "fee",
          component: "InputNumber",
          placeholder() {
            return that.$t("enter") + that.$t("reChAmount");
          },
          show({ row }) {
            return row.service_type == 2068;
          },
          default: 0,
          bind: {
            style: "width:100%",
            min: 0,
          },
        },
      ],
    },
    remarkList: {
      config: {
        modalBind: {
          width: 600,
        },
      },
      footer: {
        show: false,
      },
      table: {
        config: {
          height: 500,
        },
        fields: [
          {
            name: () => that.$t("order_desc"),
            key: "remarks",
            align: "center",
            minWidth: 140,
          },
          {
            name: () => that.$t("addTo") + that.$t("time"),
            align: "center",
            key: "create_time",
            minWidth: 110,
          },
          {
            name: () => that.$t("addTo") + that.$t("personnel"),
            align: "center",
            key: "create_name",
            minWidth: 110,
          },
        ],
      },
    },
    sheetList: {
      config: {
        modalBind: {
          width: 600,
        },
      },
      footer: {
        show: false,
      },
      table: {
        config: {
          height: 500,
        },
        fields: [
          {
            name: () => that.$t("label_url"),
            key: "link",
            align: "center",
            minWidth: 140,
          },
          {
            type: "btns",
            width: 250,
            name: () => that.$t("operation"),
            fixed: "right",
            list: [
              {
                name: () => that.$t("print"),
                type: "show",
                fnName: "showFun",
                bind: {
                  type: "warning",
                },
              },
            ],
            methods: {
              showFun({ row }) {
                window.open(row.link, "_blank");
              },
            },
          },
        ],
      },
    },
  };
};
